module.exports = __webpack_public_path__ + "static/new-knowledge-929aa24e93a7c711636c4be4b7de62e1.webp";